import { useHelpContext } from '../context/HelpContext';

export function useHelp() {
  return useHelpContext();
}

export default useHelp;
